import Swal from "sweetalert2";

/**
 * Shows a modern SweetAlert2 popup to confirm logout and handles redirection to login.
 * @param {Object} router - Vue Router instance
 */
export function confirmAndLogout(router) {
  Swal.fire({
    title: "Konfirmasi Logout",
    text: "Apakah Anda yakin ingin keluar dari sistem?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ya, Keluar",
    cancelButtonText: "Batal",
    confirmButtonColor: "#ea5455",
    cancelButtonColor: "#82868b",
    reverseButtons: true,
    customClass: {
      confirmButton:
        "vs-component vs-button vs-button-danger vs-button-filled p-3 px-4 font-semibold mr-2",
      cancelButton:
        "vs-component vs-button vs-button-border vs-button-primary p-3 px-4 font-semibold",
      popup: "rounded-lg shadow-2xl",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const keys = Object.keys(localStorage);
      keys.forEach((key) => {
        if (!key.startsWith("formFilled_") && !key.startsWith("pref_")) {
          localStorage.removeItem(key);
        }
      });
      if (router) {
        router.push("/login").catch(() => {});
      }
    }
  });
}

/**
 * Shows a modern SweetAlert2 popup to confirm parent logout and redirects to /report-orangtua.
 * @param {Object} router - Vue Router instance
 */
export function confirmAndLogoutOrangTua(router) {
  Swal.fire({
    title: "Konfirmasi Logout",
    text: "Apakah Anda yakin ingin keluar dari halaman Orang Tua?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ya, Keluar",
    cancelButtonText: "Batal",
    confirmButtonColor: "#ea5455",
    cancelButtonColor: "#82868b",
    reverseButtons: true,
    customClass: {
      confirmButton:
        "vs-component vs-button vs-button-danger vs-button-filled p-3 px-4 font-semibold mr-2",
      cancelButton:
        "vs-component vs-button vs-button-border vs-button-primary p-3 px-4 font-semibold",
      popup: "rounded-lg shadow-2xl",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      localStorage.removeItem("token-orangtua");
      if (router) {
        router.push("/report-orangtua").catch(() => {});
      }
    }
  });
}

